/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
window.PXUTheme.jsCollectionCustom = {
  init: function($section) {

       // Add settings from schema to current object
    window.PXUTheme.jsCollectionCustom = $.extend(this, window.PXUTheme.getSectionData($section));
    let elementsArray = document.querySelectorAll(".variant-size__container.has_multiple_variants");
    
    $(document).on("click",".variant-size__container.has_multiple_variants>.variant-size", function() {
      // when clicked, we should see the button on the console
      const $variantForm = this.closest(".product-wrap").querySelector('.product-form');
      const $variantWrap = this.closest(".variant-size__container");
      const data = this.dataset;

      window.PXUTheme.jsCollectionCustom.switchVariant($variantForm,$variantWrap,data);
    });
    
    elementsArray.forEach(function(elem) {
      
      let selectedData = $(elem).find('.selected').data();
      let variantForm = $(elem).closest('.product-wrap').find('.product-form');

      window.PXUTheme.jsCollectionCustom.switchVariant(variantForm[0],elem,selectedData);
      
    });

    $(document.body).on('nextPageloaded',function(){
      setTimeout(function () {
          const elementsArray = document.querySelectorAll(".variant-size__container.has_multiple_variants");
          
          elementsArray.forEach(function(elem) {
            const selectedData = $(elem).find('.selected').data();
            const variantForm = $(elem).closest('.product-wrap').find('.product-form');
            window.PXUTheme.jsCollectionCustom.switchVariant(variantForm[0],elem,selectedData);
          })
      },100);
    })    
  },
  switchVariant: function($variantForm, $variantWrapper, data) {
       const $variants = $variantWrapper.querySelectorAll('.variant-size');
       const $variantSelect = $variantForm.querySelector('.variant-selection__variants');
       const $price = $variantWrapper.closest('.product-thumbnail').querySelector('.product-thumbnail__price.price .money');
      //switch the option
      //$variantSelect.value = data.variant_id
      for (const v of $variants){
        if(v.dataset.variantId == data.variantId){
          v.classList.add('selected');
          $variantSelect.value = data.variantId;
          $price.textContent = data.variantPrice;
        }else{
          v.classList.remove('selected');
        }
      }
    
  },
  delegate: function(container, selector, event, listener) {
  container.addEventListener(event, function(e) {
    // did this trigger on an element matching our selector?
    var matched = e.target.closest(selector);
    if (matched && container.contains(matched)) {
      // call listener, with "this" set to the target element
      listener.call(matched, e);
    }
  });
},
  unload: function($section) {
    $('#tag_filter, #sort-by').off();
    $('[data-option-filter]').off();
    $('[data-reset-filters]').off();
    $('[data-clear-filter]').off();
    $(document.body).off('nextPageloaded');
    window.PXUTheme.breadcrumbs.unload();
  }
}

/******/ })()
;